import { scriptLoadAY } from '../utils/ad-ops/scriptLoadAY'
import debug from '../utils/console'
import type { AnalyticsProps } from '../types/assertive'
import { useRevContentStore } from '../store/ad-ops/revContentStore'
import { OpenFeature } from '@openfeature/web-sdk'

const logger = debug.withTag('plugins/assertive.client')

export default defineNuxtPlugin({
  name: 'assertive',
  dependsOn: ['openfeature'],
  setup: async (nuxtApp) => {
    const { client } = await useOpenFeature()
    const { track } = useAnalytics()

    const { ayEntityId } = useRuntimeConfig().public
    const layoutName = client.getStringValue('splittestname', 'control')
    const layoutSkeleton = client.getStringValue('layoutSkeleton', 'default')

    const revContentStore = useRevContentStore()
    await revContentStore.init()
    const analyticsProps: AnalyticsProps = {
      ntp_app_version: getNtpAppVersion(),
      host_browser_app_version: await getHostBrowserAppVersion(),
      type_tag: await getTypeTag(),
    }

    const openFeatureContext = OpenFeature.getContext()

    const ayLoaded = await scriptLoadAY(
      ayEntityId,
      analyticsProps,
      layoutName,
      layoutSkeleton,
      typeof openFeatureContext.cohort === 'string'
        ? openFeatureContext.cohort
        : null
    )

    if (!ayLoaded.loading) {
      logger.error('Assertive Yield SDK failed to load')
      return
    }

    logger.info('Assertive Yield loaded')

    window.ayManagerEnv.cmd.push(() => {
      window.ayManagerEnv.onEvent(
        'afterRefresh',
        (adUnitInstanceCode: string[]) => {
          adUnitInstanceCode.forEach((code) => {
            const eventData: NtpAdEvent = {
              ntp_tile_position: -1,
              ntp_ad_provider: 'programmatic',
              ntp_creative_id: '',
              ntp_placement_name: stripAYCode(code),
              ntp_ad_brand: '',
              ntp_ad_clickurl: '',
              ntp_ad_refresh: true,
            }
            track('NtpAd_Rendered', eventData)
          })
        }
      )
    })

    if (!window.analytics) {
      window.analytics = useAnalytics()
    }

    nuxtApp.provide('ayLoaded', ayLoaded)
    nuxtApp.provide('assertive', window.assertive)
  },
})
